import type { BoxProps } from '@mui/material/Box';
import { gridSystemPropKeys } from 'src/components/MuiGrid/utils/legacyGridProps';

/** Grid와 공유하지 않는 Box 전용 system prop */
export const boxOnlySystemPropKeys = [
  'textAlign',
  'color',
  'bgcolor',
  'border',
  'borderTop',
  'borderRight',
  'borderBottom',
  'borderLeft',
  'borderColor',
  'borderRadius',
  'position',
  'top',
  'right',
  'bottom',
  'left',
  'zIndex',
  'overflow',
  'overflowX',
  'overflowY',
  'boxShadow',
  'opacity',
  'visibility',
  'whiteSpace',
  'textOverflow',
  'lineHeight',
  'fontSize',
  'fontWeight',
  'letterSpacing',
] as const;

/** MUI 9에서 Box DOM으로 새지 않도록 system prop을 sx로 이동 */
export const boxSystemPropKeys = [
  ...gridSystemPropKeys,
  ...boxOnlySystemPropKeys,
] as const;

type BoxSystemPropKey = (typeof boxSystemPropKeys)[number];

type LegacyBoxSystemProps = Partial<Record<BoxSystemPropKey, unknown>>;

export type LegacyBoxProps = BoxProps & LegacyBoxSystemProps;

export const splitLegacyBoxProps = (props: LegacyBoxProps) => {
  const { sx, ...rest } = props;
  const systemSx: Partial<Record<BoxSystemPropKey, unknown>> = {};
  const forwardedProps: Record<string, unknown> = { ...rest };

  boxSystemPropKeys.forEach((systemPropKey) => {
    if (systemPropKey in forwardedProps) {
      systemSx[systemPropKey] = forwardedProps[systemPropKey];
      delete forwardedProps[systemPropKey];
    }
  });

  const mergedSx =
    Object.keys(systemSx).length > 0
      ? { ...systemSx, ...(sx as object | undefined) }
      : sx;

  return {
    forwardedProps,
    mergedSx,
  };
};
